import { useState, useEffect, useRef } from 'react';

/**
 * 지하철 정보 툴팁의 상태, 이벤트 핸들러, ref를 관리한다.
 *
 * @param {{ trackPosition?: boolean }} options - trackPosition이 true이면 클릭 위치를 기록한다
 * @returns {{
 *   showSubwayTooltip: boolean,
 *   selectedSubwayInfo: object|null,
 *   tooltipPosition: { x: number, y: number },
 *   tooltipRef: React.RefObject,
 *   handleShowSubwayInfo: function,
 *   handleCloseSubwayTooltip: function
 * }}
 */
export function useSubwayTooltip({ trackPosition = false } = {}) {
  const [showSubwayTooltip, setShowSubwayTooltip] = useState(false);
  const [selectedSubwayInfo, setSelectedSubwayInfo] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const tooltipRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowSubwayTooltip(false);
      }
    }

    function handleScroll() {
      if (showSubwayTooltip) {
        setShowSubwayTooltip(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showSubwayTooltip]);

  const handleShowSubwayInfo = (e, item) => {
    e.preventDefault();

    if (item.subwaystationname) {
      setSelectedSubwayInfo(item);
      setShowSubwayTooltip(true);

      if (trackPosition) {
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltipPosition({
          x: rect.left,
          y: rect.bottom + window.scrollY,
        });
      }
    }
  };

  const handleCloseSubwayTooltip = () => {
    setShowSubwayTooltip(false);
  };

  return {
    showSubwayTooltip,
    selectedSubwayInfo,
    tooltipPosition,
    tooltipRef,
    handleShowSubwayInfo,
    handleCloseSubwayTooltip,
  };
}
